<template lang="pug">
  #ChallengeCompletionDate.is-flex.is-flex-direction-column
    BDatepicker.date-picker(
      placeholder="Choose date"
      name="completion date"
      icon="calendar-today"
      v-model="completionDate"
      :date-formatter="(date) => this.date(date, 'DATE_FORMAT_SHORT_MONTH').formatted"
      :min-date="minCompletionDate"
      :max-date="maxCompletionDate"
      :disabled="isCompleted"
    )
    br
    WtButton(
      bold
      @click.native="submit"
      :disabled="disableSave"
    ) {{updateCompletionDate ? 'Update' : 'Submit'}}
</template>

<script>
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";
import WtButton from "@@/WtButton/WtButton";
import { mapActions } from "vuex";

export default {
  name: "ChallengeCompletionDate",

  components: { WtButton },

  mixins: [dateUtilityMixin],

  props: {
    challenge: {
      type: Object,
      default: () => {}
    },
    isCompleted: {
      type: Boolean,
      default: false
    },
    openPointsAwardedModal: {
      type: Function,
      default: () => {}
    }
  },

  data() {
    return {
      completionDate: this.challenge.completionDate
        ? this.date(this.challenge.completionDate).dateObject
        : undefined
    };
  },

  computed: {
    minCompletionDate() {
      return this.moment(this.challenge.startDate)._d;
    },

    maxCompletionDate() {
      return this.moment(this.challenge.endDate)._d;
    },

    initialDate() {
      return this.challenge.completionDate
        ? this.date(this.challenge.completionDate).dateObject
        : undefined;
    },

    updateCompletionDate() {
      return !!this.initialDate;
    },

    disableSave() {
      if (this.isCompleted) {
        return true;
      }
      return (
        !this.completionDate ||
        this.moment(this.completionDate).isSame(this.moment(this.initialDate))
      );
    }
  },

  methods: {
    ...mapActions("members", [
      "mobileAddCompletionDateForPreventativeChallenge"
    ]),
    ...mapActions("challenges", ["updateStateForMobileChallenge"]),
    ...mapActions(["snackBar"]),

    async submit() {
      if (this.completionDate) {
        try {
          let payload = {
            mobileToken: this.$route.params.mobileToken,
            challengeId: this.challenge.id,
            completionDate: this.formatDateForRequest(this.completionDate)
          };
          let response = await this.mobileAddCompletionDateForPreventativeChallenge(
            payload
          );
          if (!this.updateCompletionDate) {
            this.snackBar({ message: "Your completion date was saved." });
          } else {
            this.snackBar({ message: "Your completion date was updated." });
          }
          this.updateStateForMobileChallenge(response.data);
          this.completionDate = this.date(
            response.data.completionDate
          ).dateObject;
          // display points awarded modal if request successful
          if (
            response.pointsAwarded &&
            response.pointsAwarded.status === "success"
          ) {
            this.openPointsAwardedModal(
              this._.get(response, "pointsAwarded.pointsAwarded", null)
            );
          }
        } catch (e) {
          let errorMessage =
            this._.get(e, "data.error.message", null) || e.statusText;
          this.completionDate = this.initialDate;
          this.snackBar({
            duration: 5000,
            type: "is-danger",
            message: errorMessage
          });
        }
      }
    }
  }
};
</script>

<style lang="sass" scoped>
#ChallengeCompletionDate
  .date-picker
    /deep/ input
      font-family: $family-sans-serif-bold
      border: 1px solid $grey
      border-radius: $radius
      padding-top: 0.6rem
      text-align: center
    /deep/ input::placeholder
      color: $black !important
    /deep/ .icon
      padding-left: 10px
</style>
